function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .st0, .st1, .st2 {\n        fill-rule: evenodd;\n      }\n\n      .st0, .st1, .st3 {\n        fill: #fff;\n      }\n\n      .st1 {\n        isolation: isolate;\n        opacity: .5;\n      }\n\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M46,173.6c-5.6,0-9-4.6-9-11.8h0c0-7.3,3.4-11.9,9-11.9s9,4.5,9,11.8h0c0,7.3-3.4,11.9-9,11.9ZM46,169.8c2.7,0,4.2-3,4.2-8.1h0c0-5.1-1.5-8.1-4.2-8.1s-4.2,3-4.2,8.1h0c0,5.1,1.5,8.1,4.2,8.1Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M140.1,173v-18.1h-.3l-5.5,3.8v-4.2l5.8-4h4.7v22.5h-4.7Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M226.5,173v-3.2l7.3-7.2c3.2-3.1,4-4.2,4-5.8h0c0-2-1.3-3.3-3.5-3.3s-3.7,1.5-3.7,3.6h-4.4c0-4.4,3.4-7.4,8.3-7.4s7.9,2.7,7.9,6.5h0c0,2.6-1.3,4.7-5.4,8.5l-4.2,3.9v.4h9.9v3.8h-16.3v.2Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M331,173.5c-5.1,0-8.5-2.7-8.8-6.8v-.2h4.5v.2c.2,1.8,1.8,3,4.3,3s4-1.3,4-3.2h0c0-2.2-1.6-3.4-4.3-3.4h-2.6v-3.4h2.5c2.4,0,3.9-1.2,3.9-3.1h0c0-1.9-1.3-3.1-3.5-3.1s-3.7,1.2-3.9,3.1h0c0,.1-4.3.1-4.3.1v-.2c.3-4,3.5-6.7,8.2-6.7s8,2.4,8,6h0c0,2.8-2.1,4.7-4.7,5.2h0c3.4.4,5.5,2.3,5.5,5.4h0c0,4.1-3.5,6.9-8.8,6.9v.2Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M429.7,173v-4.1h-11v-3.7c2.9-5.1,5.9-10.1,8.9-14.7h6.6v14.6h2.9v3.8h-2.9v4.1h-4.5ZM422.9,165.2h6.9v-11.2h-.2c-2.2,3.4-4.6,7.3-6.6,10.9v.2h0Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M523.2,173.6c-4.8,0-8-2.9-8.3-6.6v-.2h4.3c.3,1.8,1.9,3.1,4,3.1s4.1-1.7,4.1-4.1h0c0-2.4-1.7-4.1-4.1-4.1s-2.1.3-2.9,1c-.4.3-.8.8-1,1.2h-4l1-13.3h14.1v3.8h-10.4l-.6,6.4h.3c.9-1.5,2.7-2.5,4.8-2.5,4.2,0,7.2,3.1,7.2,7.4h0c0,4.8-3.5,8-8.6,8h.1Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M617.3,173.6c-5.2,0-9.3-3.7-9.3-11.6h0c0-7.6,3.6-12.1,9.3-12.1s7.6,2.6,8.3,6.1v.2h-4.6c-.5-1.5-1.8-2.5-3.6-2.5-3.3,0-4.7,3.2-4.9,7.3v.5h.3c.8-1.8,2.7-3.3,5.8-3.3s7.4,3.1,7.4,7.4h0c0,4.6-3.6,8-8.6,8h-.1ZM613.2,165.6c0,2.4,1.8,4.2,4.1,4.2s4.1-1.8,4.1-4.1h0c0-2.4-1.7-4.1-4.1-4.1s-4.1,1.7-4.1,4h0Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M706.6,173l9.6-18.5v-.3h-11.4v-3.8h16.1v3.8l-9.4,18.8h-4.9,0Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M809.5,173.5c-5.4,0-9.2-2.7-9.2-6.6h0c0-3,2.2-5.1,5.3-5.8h0c-2.6-.7-4.4-2.6-4.4-5.1h0c0-3.5,3.4-6.1,8.3-6.1s8.3,2.6,8.3,6.1h0c0,2.5-1.8,4.4-4.4,5h0c3.1.7,5.3,2.9,5.3,5.8h0c0,3.9-3.7,6.6-9.2,6.6h0ZM809.5,159.6c2.2,0,3.7-1.3,3.7-3.1h0c0-1.9-1.5-3.1-3.7-3.1s-3.7,1.3-3.7,3.1h0c0,1.9,1.5,3.2,3.7,3.2h0ZM809.5,170.1c2.5,0,4.2-1.5,4.2-3.5h0c0-2.1-1.7-3.5-4.2-3.5s-4.2,1.5-4.2,3.5h0c0,2.1,1.8,3.5,4.2,3.5Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M906.7,149.9c5.2,0,9.3,3.7,9.3,11.6h0c0,7.6-3.6,12.1-9.3,12.1s-7.6-2.6-8.3-6.1h0c0-.1,4.6-.1,4.6-.1h0c.5,1.5,1.8,2.5,3.6,2.5,3.3,0,4.7-3.2,4.9-7.3v-.5h-.3c-.8,1.7-2.7,3.3-5.8,3.3s-7.3-3.1-7.3-7.4h0c0-4.6,3.6-8,8.6-8h0ZM906.7,161.8c2.3,0,4.1-1.7,4.1-4h0c0-2.4-1.8-4.2-4.1-4.2s-4.1,1.8-4.1,4.1h0c0,2.4,1.7,4.1,4.1,4.1h0Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M987.2,173v-18.1h-.3l-5.5,3.8v-4.2l5.8-4h4.7v22.5h-4.7ZM1006.7,173.6c-5.6,0-9-4.6-9-11.8h0c0-7.3,3.4-11.9,9-11.9s9,4.5,9,11.8h0c0,7.3-3.4,11.9-9,11.9ZM1006.7,169.8c2.7,0,4.2-3,4.2-8.1h0c0-5.1-1.5-8.1-4.2-8.1s-4.2,3-4.2,8.1h0c0,5.1,1.5,8.1,4.2,8.1Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M46,116h955v6H46v-6Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M95,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM190,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM285,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM380,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM475,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM570,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM665,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM760,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM855,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7ZM950,112c3.9,0,7,3.1,7,7s-3.1,7-7,7-7-3.1-7-7,3.1-7,7-7Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M44,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM139,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM234,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM329,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM424,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM519,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM614,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM709,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM804,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM899,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27ZM996,106.5c0-1.4,1.1-2.5,2.5-2.5h0c1.4,0,2.5,1.1,2.5,2.5v27c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5v-27Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  fill: "current",
  d: "M44,115c0-1.1.9-2,2-2h471c1.1,0,2,.9,2,2v8c0,1.1-.9,2-2,2H46c-1.1,0-2-.9-2-2v-8Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  fill: "current",
  d: "M520.8,7c22.1,0,40.2,16.1,40.2,36.1s-22.6,38.1-37.6,52.2c-1.6,1.5-3.2,1.5-4.7,0-15-14.1-37.6-32.8-37.6-52.2s17.7-36.1,39.8-36.1h-.1Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M512,93.3c-6.5-6-13.9-12.8-20.1-20.1-9.4-11-13.9-20.8-13.9-30,0-21.6,19.2-39.1,42.8-39.1s43.2,17.6,43.2,39.1-4.5,19-13.9,30c-6.2,7.3-13.6,14.1-20.1,20.1-1.6,1.5-6.9,6.8-9,6.8s-7.5-5.3-9-6.8ZM520.8,7c-22,0-39.8,16.2-39.8,36.1s4.3,17.6,13.2,28.1c6,7.1,13.4,13.9,19.8,19.8,1.6,1.5,3.2,2.9,4.6,4.3.5.5,1,1,1.4,1.2.8.6,1.1.6,1.9,0,.4-.3.9-.7,1.4-1.2,1.5-1.4,3-2.8,4.6-4.3,6.5-6,13.8-12.7,19.8-19.8,8.9-10.5,13.2-19.6,13.2-28.1,0-19.9-18-36.1-40.2-36.1h0Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "st3",
  d: "M519.8,61.7c-6,0-10-3.6-10.4-8.3v-.3h5.3c.4,2.2,2.3,3.9,5,3.9s5.1-2.1,5.1-5.2h0c0-3-2.1-5.1-5.1-5.1s-2.6.4-3.6,1.2c-.5.4-1,1-1.3,1.6h-5.1l1.3-16.7h17.6v4.7h-13l-.7,8h.4c1.1-1.9,3.3-3.1,6-3.1,5.3,0,9,3.9,9,9.2h0c0,6-4.4,10-10.7,10h.2Z"
});

var SvgScaleSet = function SvgScaleSet(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 1042 178",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScaleSet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scale_set.7eee942c.svg";
export { ForwardRef as ReactComponent };